var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutmodel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 40,
    fill: "#006EC2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1496_22684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5003 57.3337C30.9271 57.3337 23.167 49.5735 23.167 40.0003C23.167 30.4271 30.9271 22.667 40.5003 22.667C43.1915 22.6656 45.8459 23.2916 48.2529 24.4951C50.66 25.6986 52.7534 27.4466 54.367 29.6003H49.6697C47.6681 27.8354 45.1997 26.6855 42.5608 26.2886C39.9218 25.8918 37.2244 26.2648 34.7923 27.363C32.3601 28.4611 30.2964 30.2378 28.849 32.4797C27.4015 34.7217 26.6317 37.3336 26.6319 40.0022C26.6321 42.6709 27.4024 45.2827 28.8502 47.5244C30.2981 49.7661 32.362 51.5424 34.7944 52.6402C37.2267 53.7379 39.9242 54.1105 42.563 53.7132C45.2019 53.3159 47.6701 52.1656 49.6714 50.4003H54.3687C52.7549 52.5543 50.6613 54.3024 48.2539 55.506C45.8465 56.7095 43.1918 57.3353 40.5003 57.3337ZM52.6337 46.9337V41.7337H38.767V38.267H52.6337V33.067L61.3003 40.0003L52.6337 46.9337Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_22684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6,
    height: 41.6,
    fill: "white",
    transform: "translate(19.7002 19.2002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutmodel);
export default __webpack_public_path__ + "static/media/logoutmodel.10f4cfad464394fa50da9113c534d874.svg";
export { ForwardRef as ReactComponent };